import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import * as theme from "../theme";
const PlusIcon = ({ color, onClick }) => {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 50,
        height: 15,
        width: 15,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      <AddCircleOutlinedIcon
        style={{
          color: color ? color : theme.COLORS.qf_nav_plus_button_color,

          borderRadius: 100,
        }}
      ></AddCircleOutlinedIcon>
    </div>
  );
};

export default PlusIcon;
